import { DatabaseMarkerOutlineIcon } from './DatabaseMarkerOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 163262B4-672A-4194-B002-3F414DF6C7A5
 * name database-marker-outline
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/database-marker-outline.svg
 * tags
 * - Database 
 * - Navigation 
 */
export const DatabaseLocationOutlineIcon = DatabaseMarkerOutlineIcon;
export default DatabaseLocationOutlineIcon